import React from 'react';
import { TableContainer } from './actionPlanList.styled';
import Skeleton from 'react-loading-skeleton';

export function ActionPlanListSkeleton () {
  return (
    <TableContainer>
      <Skeleton
        containerClassName="flex-1"
        height={40}
        borderRadius={5}
        count={10}
      />
    </TableContainer>
  );
}
